import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Typography } from 'antd';
import PrivilegeError from './error/PrivilegeError';
import Home from './home';
import UserPermission from './users/UserPermission';
import UserList from './users/UserList';
import Profile from './auth/Profile';
import Config from './config';
import ServiceList from './services/ServiceList';
import CustomerList from './customers/Index';
import CustomerClassList from './customer-class/CustomerClassList';
import CustomerStatusList from './customer-status/CustomerStatusList';
import CustomerSourceList from './customer-sources/CustomerSourceList';
import InteractionStatusList from './interaction-statuses/InteractionStatusList';
import InteractionTypeList from './interaction-types/InteractionTypeList';
import UnitList from './units/UnitList';
import PageManagerList from './page-manager/PageManagerList';
import messenger from './messenger';
import BranchList from './branch/BranchList';
import RoleGroup from './role-groups/RoleGroupList';
import RoleList from './roles/RoleList';
import DiseasesList from './diseases/DiseasesList';
import BloodGroupList from './blood-groups/BloodGroupList';
import ProductList from './product/ProductList';
import ProductGroupList from './product-group/ProductGroupList';
import ProductSupplierList from './product-supplier/ProductSupplierList';
import ProductWarehouseList from './product-warehouse/ProductWarehouseList';
import ProductStatusList from './product-status/ProductStatusList';
import ProductReceiptImportList from './product-receipt-import/ProductReceiptImportList';
import GuideList from './guide/GuideList';
import GuideDetail from './guide/GuideDetail';
import WorkReportList from './work-report/WorkReportList';
import PaymentVoucherList from './payment-voucher/PaymentVoucherList';
import ViewPhonenumberList from './view-phonenumber/ViewPhonenumberList';
import CashBookList from './cash-book/CashBookList';
import RelationshipTypeList from './relationship-types/RelationshipTypeList';
import CustomerGroupList from './customer-groups/CustomerGroupList';
import ZaloOAList from '@/routes/zalo-oa/ZaloOAList';
import RevenueReport from '@/routes/statistics/RevenueReport';
import AuditLogSearch from '@/routes/audit-logs/AuditLogSearch';
import LaboList from '@/routes/labos/LaboList';
import LaboCaseList from '@/routes/labo-cases/LaboCaseList';
import FeedbackRequestList from '@/routes/feedback-requests/FeedbackRequestList';
import FeedbackRequestDetail from '@/routes/feedback-requests/FeedbackRequestDetail';
import LaboStatistics from '@/routes/labo-cases/LaboStatistics';
import InventoryStats from './product/InventoryStats';
import CustomerDetail from './customers/Detail/Index';
import MilestoneList from './cus-service-milestones/MilestoneList';
import InstructionTemplateList from './instruction-templates/InstructionTemplateList';
import ProcedureList from './procedures/ProcedureList';
import PrescriptionTemplateList from './prescription-templates/PrescriptionTemplateList';
import OrthodonticCustomerList from './customers/OrthodonticCustomerList';
import NotificationList from './notifications/NotificationList';
import StaffRevenueReport from './statistics/StaffRevenueReport';
import StaffRevenueYearly from './statistics/StaffRevenueYearly';
import StaffIncomeReport from './statistics/StaffIncomeReport';
import CustomerCareCategoryList from './customer-care-categories/CustomerCareCategoryList';
import Monitoring from './monitoring/Monitoring';
import TelesaleFollowUpList from './telesale-follow-ups/TelesaleFollowUpList';
import AssistantsSupportCases from './statistics/AssistantsSupportCases';
import TreatmentSessionList from './treatment-sessions/TreatmentSessionList';
import CustomerVisits from './statistics/CustomerVisits';
import DoctorCustomerIndex from './doctor-customers/Index';
import DoctorAppointmentIndex from './doctor-appointments/Index';
import BranchFundList from './branch-funds/BranchFundList';
import AppointmentList from './appointments/AppointmentList';
import CustomerServiceList from './customer-services/CustomerServiceList';
import LookupCustomerList from './lookup-customers/LookupCustomerList';
import CustomerProspectList from './customer-prospects/CustomerProspectList';
import ReceiptList from './receipts/ReceiptList';
import ProductReceiptExportList from './product-receipt-export/ProductReceiptExportList';
import CommissionPolicyPage from './commission-policies/CommissionPolicyPage';
import CommissionServicePolicyPage from './commission-policies/CommissionServicePolicyPage';
import CommissionDashboard from './commissions/CommissionDashboard';
import CommissionControlPage from './commissions/CommissionControlPage';
import CommissionPayoutHubPage from './commissions/CommissionPayoutHubPage';

const { Title } = Typography;


const ProtectedRoute = ({ authUser, permission, action = 'list', component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (!authUser) return <Redirect to="/login" />;

            // Admin luôn được quyền
            if (authUser.role_code === 'ADMIN') return <Component {...props} />;

            // Nếu không khai báo permission → luôn cho phép
            if (!permission) return <Component {...props} />;

            // Nếu có permission, mới kiểm tra action
            const userActions = authUser?.permissions?.[permission] || [];
            const actionList = action.split(',').map(a => a.trim());
            const hasPermission = actionList.some(act => userActions.includes(act));

            if (hasPermission) return <Component {...props} />;

            return (
                <div className="text-center mt-4">
                    <Title>Permission access is denied</Title>
                </div>
            );
        }}
    />
);

const routes = [
    {
        path: '/',
        component: Home,
        permission: null
    },
    {
        path: '/error/403',
        component: PrivilegeError,
        permission: null
    },
    {
        path: '/profile',
        component: Profile,
        permission: null
    },
    {
        path: '/users',
        component: UserList,
        permission: 'users',
        action: 'list'
    },
    {
        path: '/permissions',
        component: UserPermission,
        permission: 'permissions',
        action: 'list'
    },
    {
        path: '/config',
        component: Config,
        permission: 'config',
        action: 'update'
    },
    {
        path: '/services',
        component: ServiceList,
        permission: 'services',
        action: 'list'
    },
    {
        path: '/customers',
        component: CustomerList,
        permission: 'customer',
        action: 'list'
    },
    {
        path: '/customer-class',
        component: CustomerClassList,
        permission: 'customer_class',
        action: 'list'
    },
    {
        path: '/customer-status',
        component: CustomerStatusList,
        permission: 'customer_status',
        action: 'list'
    },
    {
        path: '/customer-sources',
        component: CustomerSourceList,
        permission: 'customer_source',
        action: 'list'
    },
    {
        path: '/interaction-statuses',
        component: InteractionStatusList,
        permission: 'interaction_statuses',
        action: 'list'
    },
    {
        path: '/interaction-types',
        component: InteractionTypeList,
        permission: 'interaction_types',
        action: 'list'
    },
    {
        path: '/page-list',
        component: PageManagerList,
        permission: 'page_manager',
        action: 'list'
    },
    {
        path: '/messenger',
        component: messenger,
        permission: 'messenger',
        action: 'thread'
    },
    {
        path: '/branches',
        component: BranchList,
        permission: 'branch',
        action: 'list'
    },
    {
        path: '/role-groups',
        component: RoleGroup,
        permission: 'role_groups',
        action: 'list'
    },
    {
        path: '/roles',
        component: RoleList,
        permission: 'roles',
        action: 'list'
    },
    {
        path: '/diseases',
        component: DiseasesList,
        permission: 'diseases',
        action: 'list'
    },
    {
        path: '/blood-groups',
        component: BloodGroupList,
        permission: 'blood_groups',
        action: 'list'
    },
    {
        path: '/customer-services',
        component: CustomerServiceList,
        permission: 'customer_services',
        action: 'list'
    },
    {
        path: '/product-list',
        component: ProductList,
        permission: 'product',
        action: 'list'
    },
    {
        path: '/product-statistics',
        component: InventoryStats,
        permission: 'product',
        action: 'statistics'
    },
    {
        path: '/product-group',
        component: ProductGroupList,
        permission: 'product_group',
        action: 'list'
    },
    {
        path: '/product-supplier',
        component: ProductSupplierList,
        permission: 'product_supplier',
        action: 'list'
    },
    {
        path: '/warehouse',
        component: ProductWarehouseList,
        permission: 'product_warehouse',
        action: 'list'
    },
    {
        path: '/receipt-import',
        component: ProductReceiptImportList,
        permission: 'product_receipt_import',
        action: 'list'
    },
    {
        path: '/receipt-export',
        component: ProductReceiptExportList,
        permission: 'product_receipt_export',
        action: 'list'
    },
    {
        path: '/appointments',
        component: AppointmentList,
        permission: 'appointment',
        action: 'list'
    },
    {
        path: '/units',
        component: UnitList,
        permission: 'unit',
        action: 'list'
    },
    {
        path: '/guide',
        component: GuideList,
        permission: 'guide',
        action: 'list'
    },
    {
        path: '/guide/:id',
        component: GuideDetail,
        permission: 'guide',
        action: 'detail'
    },
    {
        path: '/work-report',
        component: WorkReportList,
        permission: 'work_report',
        action: 'list'
    },
    {
        path: '/product-status',
        component: ProductStatusList,
        permission: 'product_status',
        action: 'list'
    },
    {
        path: '/lookup-customers',
        component: LookupCustomerList,
        permission: 'lookup_customer',
        action: 'list'
    },
    {
        path: '/customer-prospects',
        component: CustomerProspectList,
        permission: 'customer_prospect',
        action: 'list'
    },
    {
        path: '/receipts',
        component: ReceiptList,
        permission: 'receipt',
        action: 'list'
    },
    {
        path: '/payment-voucher',
        component: PaymentVoucherList,
        permission: 'payment_voucher',
        action: 'list'
    },
    {
        path: '/view-phonenumber',
        component: ViewPhonenumberList,
        permission: 'view_phonenumber',
        action: 'list'
    },
    {
        path: '/audit-logs',
        component: AuditLogSearch,
        permission: 'audit_logs'
    },
    {
        path: '/cash-book',
        component: CashBookList,
        permission: 'cash_book',
        action: 'list'
    },
    {
        path: '/relationship-types',
        component: RelationshipTypeList,
        permission: 'relationship_types',
        action: 'list'
    },
    {
        path: '/customer-groups',
        component: CustomerGroupList,
        permission: 'customer_group',
        action: 'list'
    },
    {
        path: '/commissions',
        component: CommissionDashboard,
        permission: 'commission',
        action: 'employee_commission_dashboard'
    },
    {
        path: '/commission-policies',
        component: CommissionPolicyPage,
        permission: 'commission_config',
        action: 'view'
    },
    {
        path: '/commission-service-policies',
        component: CommissionServicePolicyPage,
        permission: 'commission_config',
        action: 'view'
    },
    {
        path: '/commission-control',
        component: CommissionControlPage,
        permission: null
    },
    {
        path: '/commission-payout',
        component: CommissionPayoutHubPage,
        permission: null
    },
    {
        path: '/zalo-oa',
        component: ZaloOAList,
        permission: 'zalo',
        action: 'list'
    },
    {
        path: '/revenue-report',
        component: RevenueReport,
        permission: 'statistics',
        action: 'revenue'
    },
    {
        path: '/labos',
        component: LaboList,
        permission: 'labos',
        action: 'list'
    },
    {
        path: '/labo-cases',
        component: LaboCaseList,
        permission: 'labo_cases',
        action: 'list'
    },
    {
        path: '/labo-statistics',
        component: LaboStatistics,
        permission: 'labo_cases',
        action: 'status_statistics, customer_statistics'
    },
    {
        path: '/feedback-requests',
        component: FeedbackRequestList,
        permission: 'feedback_requests',
        action: 'list'
    },
    {
        path: '/feedback-requests/:id',
        component: FeedbackRequestDetail,
        permission: 'feedback_requests',
        action: 'detail'
    },
    {
        path: '/branch-funds',
        component: BranchFundList,
        permission: 'branch_fund',
        action: 'list'
    },
    // {
    //     path: '/partner-customers',
    //     component: PartnerCustomerList,
    //     permission: 'partner_customers',
    //     action: 'list'
    // },
    {
        path: '/procedures',
        component: ProcedureList,
        permission: 'procedures',
        action: 'list'
    },
    {
        path: '/instruction-templates',
        component: InstructionTemplateList,
        permission: 'instruction_templates',
        action: 'list'
    },
    {
        path: '/prescription-templates',
        component: PrescriptionTemplateList,
        permission: 'prescription_templates',
        action: 'list'
    },
    {
        path: '/customer/:id',
        component: CustomerDetail,
        permission: 'customer',
        action: 'detail'
    },
    {
        path: '/milestone-invisalign',
        component: MilestoneList,
        permission: 'milestones',
        action: 'list'
    },
    {
        path: '/orthodontic-customers',
        component: OrthodonticCustomerList,
        permission: 'customer',
        action: 'orthodontic_customer'
    },
    {
        path: '/notifications',
        component: NotificationList,
        permission: null,
        action: 'list'
    },
    {
        path: '/staff-revenue-report',
        component: StaffRevenueReport,
        permission: 'statistics',
        action: 'staff_revenue_detail'
    },
    {
        path: '/staff-revenue-yearly',
        component: StaffRevenueYearly,
        permission: 'statistics',
        action: 'staff_revenue_yearly'
    },
    {
        path: '/staff-income-report',
        component: StaffIncomeReport,
        permission: 'statistics',
        action: 'staff_revenue_detail'
    },
    {
        path: '/customer-care-categories',
        component: CustomerCareCategoryList,
        permission: 'customer_care_categories',
        action: 'list'
    },
    {
        path: '/monitoring',
        component: Monitoring,
        permission: 'monitorings',
        action: 'view'
    },
    {
        path: '/telesale-follow-ups',
        component: TelesaleFollowUpList,
        permission: 'telesale_follow_up',
        action: 'list'
    },
    {
        path: '/assistants-support-cases',
        component: AssistantsSupportCases,
        permission: 'statistics',
        action: 'assistants_support_cases'
    },
    {
        path: '/treatment-sessions',
        component: TreatmentSessionList,
        permission: 'treatment_sessions',
        action: 'list'
    },
    {
        path: '/customer-visits',
        component: CustomerVisits,
        permission: 'statistics',
        action: 'customer_visits'
    },
    {
        path: '/doctor-customers',
        component: DoctorCustomerIndex,
        permission: 'doctor_customers',
        action: 'list'
    },
    {
        path: '/doctor-appointments',
        component: DoctorAppointmentIndex,
        permission: 'doctor_appointments',
        action: 'list'
    }
];

class Routes extends Component {

    render() {
        var { authUser } = this.props;

        return (
            <Switch>
                {routes.map((route, index) => (
                    <ProtectedRoute
                        key={index}
                        exact
                        path={route.path}
                        authUser={authUser}
                        permission={route.permission}
                        action={route.action || 'list'}
                        component={route.component}
                    />
                ))}
            </Switch>
        )
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

export default connect(mapStateToProps, null)(Routes);

